import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Ether } from 'types'

export function useOrderStopPrice() {
  return useSelector<RootState, Ether>((state) => state.order.stopPrice)
}
